import React from 'react';
import type { OmdPanelTabId } from '../../utils/omdProductView';
import { getOmdTabIcon, OmdPanelIcon } from './omdPanelIcons';

type OmdPanelTabNavProps = {
  tabs: Record<OmdPanelTabId, string>;
  activeTab: OmdPanelTabId;
  onTabChange: (tab: OmdPanelTabId) => void;
};

export function OmdPanelTabNav({ tabs, activeTab, onTabChange }: OmdPanelTabNavProps) {
  return (
    <nav className="flex border-t border-app-border px-2" aria-label="Produktdetail-Bereiche">
      {(Object.entries(tabs) as [OmdPanelTabId, string][]).map(([id, label]) => {
        const active = id === activeTab;
        return (
          <button
            key={id}
            type="button"
            role="tab"
            aria-selected={active}
            onClick={() => onTabChange(id)}
            className={`inline-flex items-center gap-1.5 px-4 py-2.5 text-sm font-medium border-b-2 transition-colors -mb-px ${
              active
                ? 'border-pipedrive-blue text-pipedrive-blue'
                : 'border-transparent text-app-text-subtle hover:text-app-text hover:border-app-border'
            }`}
          >
            <OmdPanelIcon icon={getOmdTabIcon(id)} />
            {label}
          </button>
        );
      })}
    </nav>
  );
}
